import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { store } from 'react-notifications-component';

import Button from 'components/Button/Button';
import { getScale } from 'utils/Visor';

import './PrintSelection.css';

declare var CONFIGURATIONS;

class PrintSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateSelected: '21.0x29.7',
      scale: this.selectScale(),
      scaleCustom: '',
      orientation: 'V',
      certify: false,
    };
  }

  selectScale = () => {
    const scales = CONFIGURATIONS.scales;
    const num = getScale()/4;
    let res = scales[0];
    for (let i = 0; i < scales.length - 1; i++) {
      let l = scales[i];
      let u = scales[i + 1];
      if (l < num && u > num) {
        if (Math.abs(num - l) < Math.abs(num - u)) {
          res = l;
        } else {
          res = u;
        }
        break;
      }
    }

    return res;
  }

  changeProperty = (property, evt) => {
    let value = evt.target.value;
    let newState = this.state;

    if (property === 'scale') {
      value = parseInt(value, 10);
    } else if (property === 'scaleCustom') {
      value = parseInt(value, 10);
      if (isNaN(value)) {
        value = '';
      }
    } else if (property === 'certify') {
      value = !this.state.certify;
    }

    newState[property] = value;
    this.setState(newState);
  }

  accept = () => {
    const { t } = this.props;
    const { templateSelected, scale, certify, scaleCustom, orientation } = this.state;
    let scaleSelected = scale;
    if (scaleCustom !== '') {
      scaleSelected = scaleCustom;
    }

    let template = templateSelected;
    if (templateSelected.startsWith('21.0')) {
      if (orientation === 'V') {
        template = 'A4 Vertical';
      } else {
        template = 'A4 Horizontal';
      }
    } else if (templateSelected.startsWith('29.7')) {
      if (orientation === 'V') {
        template = 'A3 Vertical';
      } else {
        template = 'A3 Horizontal';
      }
    } else {
      if (orientation !== 'V') {
        const sizes = templateSelected.split('x').reverse();
        template = sizes[0] + 'x' + sizes[1];
      }
    }

    const component = <div className='notification-content notification-info'>
      <div className='notification-close'></div>
      <p className='notification-title'>{t('printSelection.info')}</p>
      <p className='notification-message'>
        <span>
          {t('printSelection.step1')}<br/>
          {t('printSelection.step2')}<br/>
          {t('printSelection.step3')}<br/>
        </span>
      </p>
    </div>;

    this.props.acceptPrint(scaleSelected, template, certify);
    store.addNotification({
      id: 'print-notification',
      title: t('printSelection.info'),
      type: 'info',
      insert: 'top',
      content: component,
      container: 'top-center',
      animationIn: ['animated', 'fadeIn'],
      animationOut: ['animated', 'zoomOut'],
      dismiss: {
        duration: 7000,
        click: true,
        touch: true,
        showIcon: true,
      },
    });
  }

  render() {
    const { t } = this.props;
    const { templateSelected, scale, /*certify,*/ scaleCustom, orientation } = this.state;

    const optionScales = [];
    CONFIGURATIONS.scales.forEach((s, index) => {
      optionScales.push(<option key={'scaleOption' + index} value={s}>{s}</option>);
    });

    return (
      <React.Fragment>
        <div className='row printSelectionRow'>
          <span>{t('printSelection.paper')}</span>
          <select id='selectTemplate' value={templateSelected} onChange={this.changeProperty.bind(null, 'templateSelected')}>
            <option value='21.0x29.7'>A4: 21.0x29.7 cm</option>
            <option value='29.7x42.0'>A3: 29.7x42.0 cm</option>
          </select>
        </div>
        <div className='row printSelectionRow'>
          <span>{t('printSelection.scale')}</span>
            <select id='selectScale' value={scale} onChange={this.changeProperty.bind(null, 'scale')} disabled={scaleCustom !== ''}>
              {optionScales}
            </select>
          <input type='number' id='customScale' name='customScale' onChange={this.changeProperty.bind(null, 'scaleCustom')} placeholder={t('printSelection.custom')} defaultValue={scaleCustom} />
        </div>
        <div className='row printSelectionRow'>
          <span>{t('printSelection.orientation')}</span>
          <select id='selectOrientation' value={orientation} onChange={this.changeProperty.bind(null, 'orientation')}>
            <option value={'V'}>{t('printSelection.vertical')}</option>
            <option value={'H'}>{t('printSelection.horizontal')}</option>
          </select>
        </div>
        {/*
        <div className='row printSelectionRow'>
          <span>{t('printSelection.request_certificate')}</span>
          <input type='checkbox' name='certify' value='certify' checked={certify}
            onChange={this.changeProperty.bind(null, 'certify')} />
        </div>
        */} 
        <div className='row printSelectionButtonContainer'>
          <Button text={t('printSelection.accept')} active={true} onClick={this.accept} />
        </div>       
      </React.Fragment>
    );
  }
}

export default translate()(PrintSelection);
